export const forms = {
  passwordAccepted: "Password accepted! Please review the terms to continue.",
  passwordError: "Password error",
  loadFormDataError: "Error loading form data",
  authorDataLoadingWarning: "Some user features may be limited due to a data loading issue.",
  anonymousAuthError: "Anonymous authentication error: {{message}}",
  recordingSubmittedSuccess: "Recording submitted successfully! Thank you for your contribution.",
  termsAccepted: "Terms accepted. You can now fill out the form.",
  signedOutSuccess: "Signed out successfully",
  signedOutFailed: "Failed to sign out",
  signOut: "Sign Out",
  audioSubmissionForm: "Audio Submission Form",
  shareAudioSubtitle: "🎙️ Share your audio and contribute to this collection",
  featureAudioRecording: "🎤 Audio Recording",
  featureProjectDetails: "📝 Project Details",
  featureDataCollection: "📊 Data Collection",
  accessRequired: "🔐 Access Required",
  accessRequiredDescription: "Please enter the project password provided to you to access the submission form.",
  savingRecording: "Saving recording...",
  unableToLoadForm: "Unable to Load Form",
  tryAgain: "Try Again",
  goBack: "Go Back",
  retryAttempts: "Retry attempts: {{count}}",
  checking: "Checking..."
}
